import { createReducer } from "@reduxjs/toolkit";
import type { Reducer } from "redux";
import { combineReducers } from "redux";

import type { Credentials } from "../../types/fe/entities/credentials";
import type { Nullable } from "../../utils/nullable";
import type { Path } from "../types/routerTypes";
import { authActions } from "./actions";
import type { AuthState } from "./types";

const authTokens: Reducer<Nullable<Credentials>> = createReducer<Nullable<Credentials>>(null, (builder) => {
    builder.addCase(authActions.setAuthToken, (_draft, action) => action.payload);
});

const userName = createReducer<string>("", (builder) => {
    builder.addCase(authActions.setUserName, (_draft, action) => {
        return action.payload ?? "";
    });
});

const redirect: Reducer<Nullable<Path>> = createReducer<Nullable<Path>>(null, (builder) => {
    builder.addCase(authActions.redirect, (_draft, action) => action.payload);
    builder.addCase(authActions.clearRedirect, () => null);
});

export const reducer: Reducer<AuthState> = combineReducers({
    authTokens,
    userName,
    redirect,
});
